import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledIntentTooltipContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
`;

export const StyledIntentTooltipHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
`;

export const StyledIntentTooltipIconWrapper = styled.div`
    display: flex;
    border-radius: 20px;
    background: linear-gradient(68deg, #e6edff 41.06%, #feecf2 89.39%);
    padding: 4px;
    margin-right: 4px;

    svg {
        fill: ${colorsPalettes.carbon[500]};
        path {
            fill: ${colorsPalettes.carbon[500]};
        }
    }
`;

export const StyledIntentTooltipHeaderTitle = styled.div`
    display: flex;
    align-items: center;
    ${mixins.setFontVariant("report", colorsPalettes.carbon["500"])};
    height: 100%;
`;

export const StyledIntentTooltipContainer = styled.div`
    display: flex;
    flex-direction: column;
    ${mixins.setFontVariant("sectionTitle", colorsPalettes.carbon["300"])};
`;

export const StyledIntentTooltipContainerItem = styled.div`
    display: list-item;
    margin-left: 20px;
    margin-bottom: 12px;
    &:last-child {
        margin-bottom: 0;
    }
`;
